import { createStore } from "@stencil/store";
import { NOTIFICATION_TYPES } from "../../../api/publicApi/createCase/notificationType";
import { SOFTWARE_TYPES } from "../../../api/publicApi/createCase/software";
import { APPLICATION_IDS } from "../../../api/publicApi/createCase/applications";
import { getErrorNumberRegexForTechnology } from "../../../api/publicApi/createCase/errorSources";
const hideMachinesForNotificationTypes = [NOTIFICATION_TYPES.PROGRAMMING_SOFTWARE];
const showErrorNumbersForNotificationTypes = [
    null,
    NOTIFICATION_TYPES.APPLICATION_ISSUES,
    NOTIFICATION_TYPES.MACHINE_STOP,
    NOTIFICATION_TYPES.FAULT_WITHOUT_STOP
];
const hideErrorNumbersForTechnologies = [];
const showSoftwareFieldsForNotificationTypes = [NOTIFICATION_TYPES.PROGRAMMING_SOFTWARE];
const showSoftwareModulesForSoftwareTypes = [SOFTWARE_TYPES.TRUTOPS, SOFTWARE_TYPES.TRUTOPS_FAB, SOFTWARE_TYPES.TRUTOPS_BOOST];
const showApplicationIssuesForNotificationTypes = [NOTIFICATION_TYPES.APPLICATION_ISSUES];
const showApplicationIssuesForTechnologies = [
    "PULSEDLASER",
    "SHORTPULSEDLASER",
    "DISKLASER",
    "FIBERLASER",
    "DIODELASER",
    "MARKINGLASER"
];
const showWeldingApplicationFieldsForApplication = [APPLICATION_IDS.WELDING];
export const createFormStore = () => {
    const store = createStore({
        selectedNotificationType: null,
        selectedSoftwareType: null,
        selectedApplication: null,
        formIsSubmitted: false,
        selectedMachineTechnology: null,
        showErrorNumbers: true,
        showApplications: false,
        showSoftwareModules: false,
        showMachines: true,
        showSoftwareFields: false,
        showWeldingApplicationFields: false,
        errorNumberRegex: getErrorNumberRegexForTechnology()
    });
    store.onChange("selectedNotificationType", (selectedNotificationType) => {
        store.state.showMachines = !hideMachinesForNotificationTypes.includes(selectedNotificationType);
        store.state.showSoftwareFields = showSoftwareFieldsForNotificationTypes.includes(selectedNotificationType);
        determineShowErrorNumbers();
        determineShowApplications();
    });
    store.onChange("selectedMachineTechnology", () => {
        determineShowErrorNumbers();
        determineShowApplications();
        determineErrorNumberRegex();
    });
    store.onChange("selectedApplication", (selectedApplication) => {
        store.state.showWeldingApplicationFields = showWeldingApplicationFieldsForApplication.includes(selectedApplication);
    });
    store.onChange("selectedSoftwareType", (selectedSoftwareType) => {
        store.state.showSoftwareModules = showSoftwareModulesForSoftwareTypes.includes(selectedSoftwareType);
    });
    function determineShowApplications() {
        const { selectedNotificationType, selectedMachineTechnology } = store.state;
        store.state.showApplications =
            showApplicationIssuesForNotificationTypes.includes(selectedNotificationType) &&
                showApplicationIssuesForTechnologies.includes(selectedMachineTechnology);
    }
    function determineErrorNumberRegex() {
        const { selectedMachineTechnology } = store.state;
        store.state.errorNumberRegex = getErrorNumberRegexForTechnology(selectedMachineTechnology);
    }
    function determineShowErrorNumbers() {
        const { selectedNotificationType, selectedMachineTechnology } = store.state;
        store.state.showErrorNumbers =
            showErrorNumbersForNotificationTypes.includes(selectedNotificationType) &&
                !(selectedMachineTechnology !== null && hideErrorNumbersForTechnologies.includes(selectedMachineTechnology));
    }
    return store;
};
//# sourceMappingURL=formStore.js.map
